// extracted by mini-css-extract-plugin
var _1 = "SeriesIcon-module__animateUploadProgressBarWidth--wNxLs";
var _2 = "SeriesIcon-module__animatedBackground--Uj8yY";
var _3 = "SeriesIcon-module__archived--EQO4r";
var _4 = "SeriesIcon-module__bordered--W217a";
var _5 = "SeriesIcon-module__icon--lEKXo";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "archived", _4 as "bordered", _5 as "icon" }
